<script>
  export let currentAudio;
  export let currentAudioTitle;
</script>

<div class="audio-player-bar">
  <div class="audio-player-content">
    <span class="current-track">{currentAudioTitle || 'No track selected'}</span>
    <audio id="mainPlayer" controls preload="auto">
      <source src={currentAudio} type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  </div>
</div>

<style>
  .audio-player-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 0.5rem;
    z-index: 1000;
  }

  .audio-player-content {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .current-track {
    font-size: 0.85rem;
    color: #666;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #mainPlayer {
    width: 100%;
  }

  @media (min-width: 640px) {
    .audio-player-bar {
      padding: 1rem;
    }

    .audio-player-content {
      flex-direction: row;
      align-items: center;
      gap: 1rem;
    }

    .current-track {
      min-width: 200px;
      font-size: 0.9rem;
      text-align: left;
    }

    #mainPlayer {
      flex: 1;
      max-width: 600px;
    }
  }
</style>
